module.exports = __webpack_public_path__ + "static/media/tyouriKiru.804c4342.png";